import React from 'react';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import useTranslate from '@hooks/useTranslate';
import { commonMessage } from '@locales/intl';
import { Handle, Position } from '@xyflow/react';
import { Button } from 'antd';

const handleStyle = {
    width: 16,
    height: 16,
    borderRadius: '50%',
    border: '3px solid #1677ff',
    background: '#fff',
    transition: 'all 0.2s ease',
};

const GroupNodeComponent = ({ data }) => {
    const translate = useTranslate();
    return (
        <div
            style={{
                padding: '16px 20px',
                borderRadius: 12,
                background: 'linear-gradient(135deg, #ffffff 0%, #f8faff 100%)',
                border: data.status === 1 ? '2px solid #1677ff' : '2px solid #d9d9d9',
                minWidth: 240,
                boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                position: 'relative',
            }}
        >
            <Handle type="target" position={Position.Left} style={{ ...handleStyle, left: -9 }} />

            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
                <div
                    style={{
                        width: 8,
                        height: 8,
                        borderRadius: '50%',
                        background: data.status === 1 ? '#52c41a' : '#ff4d4f',
                        flexShrink: 0,
                    }}
                />
                <div style={{ fontWeight: 700, fontSize: 15, color: '#1a1a2e', lineHeight: 1.2 }}>{data.label}</div>
            </div>

            {data.serverName && (
                <div style={{ fontSize: 12, color: '#8c8c8c', marginBottom: 10, paddingLeft: 16 }}>
                    {data.serverName}
                </div>
            )}

            <div
                style={{
                    display: 'flex',
                    gap: 4,
                    borderTop: '1px solid #f0f0f0',
                    paddingTop: 10,
                    marginTop: 2,
                }}
            >
                {data.onEdit && (
                    <Button
                        type="text"
                        size="small"
                        icon={<EditOutlined />}
                        onClick={data.onEdit}
                        style={{ color: '#1677ff', fontSize: 13 }}
                    >
                        {translate.formatMessage(commonMessage.edit)}
                    </Button>
                )}
                {data.onDelete && (
                    <Button
                        type="text"
                        size="small"
                        danger
                        icon={<DeleteOutlined />}
                        onClick={data.onDelete}
                        style={{ fontSize: 13 }}
                    >
                        {translate.formatMessage(commonMessage.delete)}
                    </Button>
                )}
            </div>

            <Handle type="source" position={Position.Right} style={{ ...handleStyle, right: -9 }} />
        </div>
    );
};

export default GroupNodeComponent;
